import {
  setSelectedDocumentId,
  setSplitPanelOpen,
  setGaiaObjectType,
  setDocumentCollection,
} from "./slice";
import { useAppDispatch, useAppSelector } from "app/store";
import { IFilePreviewSplitPanelState } from "./definitions";
import { DocumentCollection } from "components/documents-table/version-utils";

export const useFilePreviewSplitPanel = () => {
  const dispatch = useAppDispatch();
  const splitPanel = useAppSelector(
    (state) => state.filePreviewSplitPanel as IFilePreviewSplitPanelState
  );

  return {
    splitPanel,
    setSelectedDocumentId: (payload: string | null) => {
      dispatch(setSelectedDocumentId(payload));
    },
    setSplitPanelOpen: (payload: boolean) => {
      dispatch(setSplitPanelOpen(payload));
    },
    setGaiaObjectType: (payload: string | undefined) => {
      dispatch(setGaiaObjectType(payload));
    },
    setDocumentCollection: (payload: DocumentCollection | null) => {
      dispatch(setDocumentCollection(payload));
    },
  };
};
